/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * EventRegister
 *
 * @file EventRegister.js
 * @author Mohamed yasar arabath M
 */

import Framework from '@greenville/framework';
import {
  EVENT_BUS
} from '../constants';

export default class EventRegister {
  static registeredSubscriptions = new Map();

  /**
   * EventName: { componentId: () => {}: Unsubscribe function }
   *
   * @param {*} eventName
   * @param {*} handler
   * @param {*} componentId
   */
  static on(eventName, handler, componentId = EVENT_BUS.GLOBAL) {
    let componentUnsubscribes = EventRegister.registeredSubscriptions.get(eventName);

    if (!componentUnsubscribes) {
      componentUnsubscribes = new Map();
      EventRegister.registeredSubscriptions.set(eventName, componentUnsubscribes);
    }

    const unsubscribeFn = Framework.getEventManager().on(eventName, handler);
    // Register new event
    componentUnsubscribes.set(componentId, unsubscribeFn);

    return unsubscribeFn;
  }

  static cleanComponentEvents(componentId) {
    if (!componentId) {
      return;
    }

    EventRegister.registeredSubscriptions.forEach((componentUnsubscribeMap, eventName) => {
      if (componentUnsubscribeMap.has(componentId)) {
        const unsubscribeFn = componentUnsubscribeMap.get(componentId);
        unsubscribeFn();
        componentUnsubscribeMap.delete(componentId);

        if (componentUnsubscribeMap.size === 0) {
          EventRegister.registeredSubscriptions.delete(eventName);
        }
      }
    });
  }
}
